import { all, call, put, select } from 'redux-saga/effects';
import {
  getCustomerProductsToHireProductOffering as getCustomerProductsToHireProductOfferingBit,
} from '../bitSagas/getCustomerProductsToHireProductOffering';
import {
  getProductAfterSaleActions as getProductAfterSaleActionsBit,
} from '../bitSagas/getProductAfterSaleActions';
import { getMyProducts as getMyProductsBit } from '../bitSagas/getMyProducts';
import { initCQ, initCQAfterSale } from './ascertain';
import { megaMinderStatus } from '../minder/MegaMinder/megaMinderStatus';
import { commonActions } from '../reducers/common';
import { actions as apisNeedsActions } from '../reducers/apisNeeds';
import { actions as uiNeedsActions } from '../reducers/uiNeeds';
import { actions as loaderControlActions } from '../reducers/loaderControl';
import { deepSearchAll, intersection } from '../utils/general';
import { getProductTypesArrayByProductOfferingTypesArray } from '../utils/catalog';
import { actions as offerActions } from '../reducers/offer';
import { OTT_PRODUCTS } from '../catalogConstants';


export const PARENT_PRODUCT_TYPES = {
  internet: 'internet',
  tv: 'tv',
  mobile: 'mobile',
  phone: 'phone',
};

const offerStore = state => state.offer;
const apisNeedsStore = state => state.apiNeeds;
const getErrorManagement = state => state.errorManagement;
const flowStore = state => state.flow;

/**
 * Saga para obtener los productos del cliente.
 * @param {Object} input - Los parámetros de entrada.
 * @param {Function} input.showError - Función para mostrar errores.
 * @param {Function} input.normalizeHttpErrors - Función para normalizar errores HTTP.
 * @returns {string} - Estado del proceso de obtención de misProductos.
 */
export function* getMyProducts(input) {
  // Muestra un indicador de carga
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));

  const {
    showError,
    normalizeHttpErrors,
  } = input;

  // Crea un objeto que contiene los creadores de acciones para manejar errores y éxito
  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: commonActions.setMyProductsInfo,
  };

  const flowInfo = yield select(flowStore);

  let retryAllMobileLines = false;
  if(flowInfo.flowJson.retryAllMobileLines){
    retryAllMobileLines = true;
  }

  // Crea un objeto que contiene los parámetros necesarios para la API
  const apiParams = {
    reduxUpdate,
    normalizeHttpErrors,
    retryAllMobileLines,
  };

  let response = null;
  

  try {
    // Llama a la función generadora para obtener los productos del cliente
    response = yield call(getMyProductsBit, apiParams);
    
    // Si la respuesta es válida, devuelve el estado OK
    if (response) {
      if (response.rawData && flowInfo && flowInfo.flowJson && flowInfo.flowJson.blockFlowByProductsType) {
        const everyProductOfferingTypes = deepSearchAll(response.rawData, 'productOfferingTypes');

        const productTypes = getProductTypesArrayByProductOfferingTypesArray(everyProductOfferingTypes);

        const intersectionArray = intersection(productTypes, flowInfo.flowJson.blockFlowByProductsType);

        if (intersectionArray && Array.isArray(intersectionArray) && intersectionArray.length > 0) {
          const { handledErrors } = yield select(getErrorManagement);
          yield put(showError(handledErrors.BUSINESS_ERRORS.INCOMPATIBLE_CLIENT_PRODUCTS));
          return megaMinderStatus.KO;
        }
      }

      // Solo miramos que hay que hacer con los paquetes de tv si existe este flag en el flujo
      if (flowInfo.flowJson.searchTVHiredProductsToManage) {
        const offerInfo = yield select(offerStore);
        
        const {
          netflixObj,
          ottProductsArray,
          secondaryProductOfferings,
          productOfferingsToDowngrade,
        } = offerInfo;
        const { tvProductsCaracs } = response;
        
        let newOttProductsArray = JSON.parse(JSON.stringify(ottProductsArray));
        const newTvProductsCaracs = JSON.parse(JSON.stringify(tvProductsCaracs));
        let newSecondaryProductOfferings = JSON.parse(JSON.stringify(secondaryProductOfferings));

        // Comprobamos si nos pasan poN
        if (netflixObj) {
          const { productOffering, mode } = netflixObj;

          if (newTvProductsCaracs[productOffering] && newTvProductsCaracs[productOffering].length === 1) {
            const actualMode = newTvProductsCaracs[productOffering][0].valueId;
            delete newTvProductsCaracs[productOffering];

            yield put(offerActions.saveNetflixInfo(null));
            // Si el cliente tiene cambio de modalidad, lo metemos en saveOTTProductsInfo
            if (actualMode !== mode) {
              // CAMBIO MODALIDAD
              newOttProductsArray.push({
                productOffering,
                mode,
              });
              yield put(offerActions.saveOTTProductsInfo(newOttProductsArray));
            } else {
              newSecondaryProductOfferings = newSecondaryProductOfferings.filter(
                item => item !== netflixObj.productOffering
              )
              yield put(offerActions.setNewSecondaryProductOfferings(newSecondaryProductOfferings));
            }
          }
        }

        // Comprobamos si nos pasan poOTT
        
        if (ottProductsArray.length > 0) {
          const ottProductsToKeep = [];

          ottProductsArray.forEach(ottProduct => {
            if (newTvProductsCaracs[ottProduct.productOffering] && newTvProductsCaracs[ottProduct.productOffering].length === 1) {
              const actualMode = newTvProductsCaracs[ottProduct.productOffering][0].valueId;
              delete newTvProductsCaracs[ottProduct.productOffering];

              // Si el cliente tiene esa modalidad lo marcamos para eliminarlo de secondaryPOs
              if (actualMode === ottProduct.mode) {
                // MANTENER
                ottProductsToKeep.push(ottProduct.productOffering);
              }
            }
          });
          
          // Eliminamos los paquetes de tv secondaryPOs que el cliente quiere mantener
          ottProductsToKeep.forEach(ottProductToKeep => {
            newOttProductsArray = newOttProductsArray.filter(
              item => item.productOffering !== ottProductToKeep
            );

            newSecondaryProductOfferings = newSecondaryProductOfferings.filter(
              item => item !== ottProductToKeep
            )
          })

          yield put(offerActions.setNewSecondaryProductOfferings(newSecondaryProductOfferings));
          yield put(offerActions.saveOTTProductsInfo(newOttProductsArray));
        }

        


        // Revisamos que paquetes que tiene el cliente en parque con caracteristica, y los marcamos para dar de baja
        let newProductOfferingsToDowngrade = JSON.parse(JSON.stringify(productOfferingsToDowngrade));
        Object.keys(newTvProductsCaracs).forEach(tvProductCaracKey => {
          const tvProductCarac = newTvProductsCaracs[tvProductCaracKey];

          if (tvProductCarac) {
            // DAR DE BAJA
            if (newProductOfferingsToDowngrade === null) {
              newProductOfferingsToDowngrade = [];
            }
            if (!newProductOfferingsToDowngrade.includes(tvProductCaracKey) && OTT_PRODUCTS.includes(tvProductCaracKey)) {
              newProductOfferingsToDowngrade.push(tvProductCaracKey);
            }
          }
        });

        yield put(offerActions.saveNewProductOfferingsToDowngrade(newProductOfferingsToDowngrade));        
      }

      return megaMinderStatus.OK;
    }


    // Si la respuesta no es válida, devuelve el estado de error recuperable
    return megaMinderStatus.RECOVERABLE_ERROR;
  } catch (e) {
    // Si ocurre un error, devuelve el estado de error recuperable
    return megaMinderStatus.RECOVERABLE_ERROR;
  }
}

/**
 * Saga para obtener productos padre de un cliente para contratar una oferta concreta.
 * @param {Object} input - Los parámetros de entrada.
 * @param {Function} input.showError - Función para mostrar errores.
 * @param {Function} input.normalizeHttpErrors - Función para normalizar errores HTTP.
 * @returns {Array|null} - Un array de productos de cliente que se pueden contratar o null en caso de error.
 */
export function* getCustomerProductsToHireProductOffering(input) {
  // Selecciona la información de la oferta del estado
  const offerInfo = yield select(offerStore);
  const { productOffering } = offerInfo;

  // Muestra un indicador de carga
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));

  const {
    showError,
    normalizeHttpErrors,
  } = input;

  // Crea un objeto que contiene los creadores de acciones para manejar errores y éxito
  const reduxUpdate = {
    errorUpdate: showError,
    successUpdate: commonActions.setParentProductsToSelect,
  };

  // Crea un objeto que contiene los parámetros necesarios para la API
  const apiParams = {
    reduxUpdate,
    normalizeHttpErrors,
    productOffering,
  };

  let response = null;

  try {
    // Llama a la función generadora para obtener los productos de cliente que se pueden contratar
    response = yield call(getCustomerProductsToHireProductOfferingBit, apiParams);

    // Si la respuesta es un array con más de un elemento, oculta el indicador de carga y devuelve la respuesta
    if (response && Array.isArray(response) && response.length > 1) {
      yield put(loaderControlActions.setLoaderState({
        loading: false,
      }));
      return response;
    } else if (response && Array.isArray(response) && response.length === 1) {
      // Si la respuesta es un array con solo un elemento, llama a inicializarPedido
      yield call(initCQ, input);
    }
  } catch (e) {
    // Si ocurre un error, devuelve null
    return null;
  }
}

/**
 * Saga para obtener acciones de postVenta para producto.
 * @param {Object} input - Los parámetros de entrada.
 * @param {Function} input.showError - Función para mostrar errores.
 * @param {Function} input.normalizeHttpErrors - Función para normalizar errores HTTP.
 * @param {Object} input.product - El producto del cual obtener las acciones para postVenta.
 * @param {string} input.cisi - El identificador de especificación de consulta del cliente.
 * @returns {Object|boolean} - Un objeto con el producto y sus acciones post-venta o false en caso de error.
 */
export function* getProductAfterSaleActions(input) {
  // Activamos el estado de carga
  yield put(loaderControlActions.setLoaderState({
    loading: true,
  }));

  const {
    showError,
    normalizeHttpErrors,
    product,
    cisi,
  } = input;

  const reduxUpdate = {
    errorUpdate: showError,
  };

  const apiParams = {
    reduxUpdate,
    normalizeHttpErrors,
    productId: product.productId,
  };
  let response = null;

  try {
    // Llamamos a la API para obtener las acciones post-venta del producto
    response = yield call(getProductAfterSaleActionsBit, apiParams);

    let rejections = [];

    // Si la respuesta contiene rejections, los almacenamos
    if (response && response.rejections) {
      rejections = response.rejections;
    }

    // Si la respuesta contiene opciones, buscamos la opción cuyo customerInquirySpecId
    // sea igual a 'cisi' pasado como parámetro
    if (response && response.choices) {
      const cisiFound = response.choices.find(choice => choice.customerInquirySpecId === cisi);

      // Si se encuentra la opción correspondiente, devolvemos el producto con su nombre y rejections
      if (cisiFound) {
        const { name } = cisiFound;
        return {
          ...product,
          name,
          rejections,
        };
      }
    }

    // Devolvemos solo las rejections si no se encuentra la opción correspondiente
    return {
      rejections,
    };
  } catch (e) {
    // En caso de error, devolvemos false
    return false;
  }
}

/**
 * Normaliza una lista de productos padres para postVenta.
 * @param {Array} afterSaleParentProducts - La lista de productos padres para post venta.
 * @returns {Array} - La lista normalizada de productos padres para postVenta.
 */
const normalizeAfterSaleParentProducts = (afterSaleParentProducts) => {
  const normalizedAfterSaleParentProducts = [];

  // Recorremos cada producto de la lista
  afterSaleParentProducts.forEach(product => {
    const { productId, address, phoneNumber } = product;

    // Añadimos el producto normalizado a la lista
    normalizedAfterSaleParentProducts.push({
      id: productId, // Usamos 'productId' como 'id'
      label: address || phoneNumber, // Usamos 'address' o 'phoneNumber' como 'label'
      address: address,
      phoneNumber: phoneNumber,
    });
  });

  // Devolvemos la lista de productos normalizados
  return normalizedAfterSaleParentProducts;
}

/**
 * Saga para obtener todos los productos padres para postventa.
 * @param {Object} input - Los parámetros de entrada.
 * @param {Function} input.showError - Función para mostrar errores.
 * @param {Function} input.normalizeHttpErrors - Función para normalizar errores HTTP.
 */
export function* getEveryAfterSaleParent(input) {
  const { myProductsInfo } = yield select(apisNeedsStore);
  const { parentProductType, productOffering, cisi, parentProductId } = yield select(offerStore);

  const { showError, normalizeHttpErrors } = input;
  const { rawData: myProducts, linesMobile } = myProductsInfo;


  // Verificamos si existe 'cisi' y no hay 'productOffering', es decir, pura postVenta
  if (cisi && !productOffering) {
    if (parentProductType && PARENT_PRODUCT_TYPES[parentProductType]) {
      const productsToUse = [];
      
      if(parentProductType === PARENT_PRODUCT_TYPES.mobile){
        let selectedMobileLine = null;
        if(parentProductId){
          selectedMobileLine = linesMobile.find(lineMobile => lineMobile.productId === parentProductId);
        }
        if(selectedMobileLine){
          productsToUse.push({
            productId: selectedMobileLine.productId,
            phoneNumber: selectedMobileLine.number,
          });
        } else {
          linesMobile.forEach(lineMobile => {
            const { productId, number } = lineMobile;
            productsToUse.push({
              productId,
              phoneNumber: number,
            });
          });
        }
      } else {
        let selectedProduct = null;
        if(parentProductId){
          selectedProduct = myProducts.find(myProduct => myProduct[PARENT_PRODUCT_TYPES[parentProductType]]?.productId === parentProductId && myProduct?.phone?.linesPhone?.length === 1);
        }
        if(selectedProduct){
          const { description, fullAdress: address } = selectedProduct.phone.linesPhone[0];
          const { productId } = selectedProduct[PARENT_PRODUCT_TYPES[parentProductType]];
          productsToUse.push({
            productId,
            description,
            address,
          });
        } else {
          // Recorremos los productos del cliente
          myProducts.forEach(myProduct => {
            // Verificamos si el producto tiene el tipo de producto padre y tiene una única linea fija
            // para obtener la dirección y el id de producto
            if (myProduct[PARENT_PRODUCT_TYPES[parentProductType]] && myProduct?.phone?.linesPhone?.length === 1 ) {
              const { description, fullAdress: address, productId: landLineProductId } = myProduct.phone.linesPhone[0];
              let { productId } = myProduct[PARENT_PRODUCT_TYPES[parentProductType]];

              if (parentProductType === PARENT_PRODUCT_TYPES.phone && landLineProductId) {
                productId = landLineProductId;
              }
    
              productsToUse.push({
                productId,
                description,
                address,
              });
            }
          });
        }
      }    

      // Obtenemos las acciones post-venta de los productos
      const response = yield all(productsToUse.map(product => call(getProductAfterSaleActions, {
        normalizeHttpErrors,
        showError,
        product,
        cisi,
      })));

      // Filtramos la respuesta de las distintas invocaciones para quedarnos con las que
      // matchean con la cisi
      const afterSaleParentProducts = response.filter(product => (product.name));

      // Verificamos si hay más de un producto padre para postVenta para guardar la info
      // y hacer que se pinte la pantalla de selección de dirección
      if (afterSaleParentProducts && afterSaleParentProducts.length > 1) {
        const normalizedAfterSaleParentProducts = normalizeAfterSaleParentProducts(afterSaleParentProducts);
        yield put(uiNeedsActions.setAfterSaleParentProductsToSelect(normalizedAfterSaleParentProducts));
        return megaMinderStatus.OK;
      }

      // Verificamos si hay exactamente un producto padre para postVenta para autoseleccionarlo
      if (afterSaleParentProducts && afterSaleParentProducts.length === 1) {
        const normalizedAfterSaleParentProducts = normalizeAfterSaleParentProducts(afterSaleParentProducts);
        yield put(commonActions.setAfterSaleParentProduct(normalizedAfterSaleParentProducts[0]));

        yield call(initCQAfterSale, input);
        return megaMinderStatus.OK;
      }

      // Si no hay ni un producto padre para postVenta, vamos a verificar la causa de la incompatibilidad

      let rejectionsCount = 0;

      // Contamos el número de rejections en todas las respuestas
      if (response && Array.isArray(response)) {
        response.forEach(clientProduct => {
          if (clientProduct && clientProduct.rejections && Array.isArray(clientProduct.rejections) && clientProduct.rejections.length > 0) {
            const cisiRejection = clientProduct.rejections.find(rejection => rejection.customerInquirySpecId === cisi);
            if (cisiRejection) {
              rejectionsCount++;
            }
          }
        });
      }

      // Verificamos si todos los productos tienen la cisi como rejection
      if (rejectionsCount > 0) {
        // Si hay las mismas rejections que productos posibles se le muestra el mensaje
        // de que ya tiene el equipamiento
        if (rejectionsCount === response.length) {
          const { handledErrors } = yield select(getErrorManagement);
          yield put(showError(handledErrors.BUSINESS_ERRORS.ALREADY_HIRED_EQUIPMENT));
          return megaMinderStatus.KO;
        }

        // Si no hay las mismas rejections que productos posibles se le muestra un mensaje
        // de que puede ser que lo tenga en parque o que sea incompatible
        const { handledErrors } = yield select(getErrorManagement);
        yield put(showError(handledErrors.BUSINESS_ERRORS.UNAVAILABLE_OR_ALREADY_HIRED));
        return megaMinderStatus.KO;
      }

      // Si no hay rejections, se le muestra el mensaje de que no hay productos compatibles
      const { handledErrors } = yield select(getErrorManagement);
      yield put(showError(handledErrors.BUSINESS_ERRORS.UNAVAILABLE_PRODUCT));
      return megaMinderStatus.KO;
    }
  }

  // Verificamos si existe 'productOffering' y no hay 'cisi', es decir, postVenta fake
  if (productOffering && !cisi) {
    const response = yield call(getCustomerProductsToHireProductOffering, input);
    if (response && Array.isArray(response)) {
      const productsIds = [];
      response.forEach(product => {
        const { id } = product;
        productsIds.push(id);
      });

      const productsToUse = [];
      myProducts.forEach(myProduct => {
        if (myProduct[PARENT_PRODUCT_TYPES[parentProductType]]
          && myProduct.phone
          && myProduct.phone.linesPhone
          && myProduct.phone.linesPhone.length === 1
        ) {
          const { description, fullAdress: address } = myProduct.phone.linesPhone[0];
          const { productId } = myProduct[PARENT_PRODUCT_TYPES[parentProductType]];

          if (productsIds.indexOf(productId) !== -1) {
            productsToUse.push({
              productId,
              description,
              address,
            });
          }
        }
      });

      // Verificamos si no hay productos disponibles para mostrar error de incompatibilidad
      if (productsToUse && productsToUse.length === 0) {
        const { handledErrors } = yield select(getErrorManagement);
        yield put(showError(handledErrors.BUSINESS_ERRORS.UNAVAILABLE_PRODUCT));
        return megaMinderStatus.KO;
      }

      // Verificamos si hay exactamente un producto disponible, para autoseleccionarlo
      if (productsToUse && productsToUse.length === 1) {
        yield put(apisNeedsActions.setAfterSaleProduct(productsToUse[0]));
      }

      // Si hay más de uno se guarda para mostrarle la selección al cliente
      const normalizedAfterSaleParentProducts = normalizeAfterSaleParentProducts(productsToUse);
      yield put(uiNeedsActions.setAfterSaleParentProductsToSelect(normalizedAfterSaleParentProducts));
      return megaMinderStatus.OK;
    }
  }
}
